export default __webpack_public_path__ + "static/team-anna-3889b66b2ffb4c680e9ab35e8bf418e0.png";